import React from 'react';
import styled from 'styled-components';
import Baiken from '../../Videos/Baiken.mp4';
import Dizzy from '../../Videos/Dizzy.mp4';
import Ino from '../../Videos/Ino.mp4';
import Ram from '../../Videos/Ram.mp4';
import Sol from '../../Videos/Sol.mp4';

export default function Events() {
    return (
        <Images2>
            <StyledVideo src={Baiken} autoPlay loop muted playsInline />
            <StyledVideo src={Dizzy} autoPlay loop muted playsInline />
            <StyledVideo src={Ino} autoPlay loop muted playsInline />
            <StyledVideo src={Ram} autoPlay loop muted playsInline />
            <StyledVideo src={Sol} autoPlay loop muted playsInline />
        </Images2>
    );
}

const Images2 = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  gap: 1rem;
`;

const StyledVideo = styled.video`
  width: 100%;
  max-width: 400px; /* Default max width */
  height: auto;
  border-radius: 10px; /* Optional rounded corners */

  @media (max-width: 1170px) { /* iPhone 16 Pro Max width */
    max-width: 80vw; /* Scale video width dynamically */
  }

  @media (max-width: 900px) { /* Smaller screens */
    max-width: 90vw;
  }

  @media (max-width: 600px) { /* iPhone Mini-sized screens */
    max-width: 95vw;
  }
`;
